import SectionHeader from 'components/SectionHeader';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';

import {PdfFilenameSectionName} from '../../types';

type SectionHeaderProps = {
    sectionName: PdfFilenameSectionName;
};

const PdfFilenameSectionHeader: FC<SectionHeaderProps> = ({sectionName}) => {
    const {t} = useTranslation('Document.PdfFilenameSettings');

    return (
        <SectionHeader
            hideHR={true}
            level={2}
            title={
                <span>
                    {t(`section.${sectionName}`)}
                    <TooltipIcon
                        className="ml-2 inline-block h-3.5 text-blue-600"
                        message={t(`tooltip.${sectionName}`)}
                        size="base"
                    />
                </span>
            }
        />
    );
};

export default PdfFilenameSectionHeader;
